// --- Popup dismissed cookie ---
var PU_DISMISSED_COOKIE = "pu_dismissed";

function setPuDismissedCookie() {
  var expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie =
    PU_DISMISSED_COOKIE +
    "=1; expires=" +
    expires.toUTCString() +
    "; path=/; SameSite=Lax";
}

function isPuDismissed() {
  return document.cookie.split("; ").indexOf(PU_DISMISSED_COOKIE + "=1") !== -1;
}

// --- Google Sheets tracking ---
var SHEETS_WEBHOOK_URL =
  "https://script.google.com/macros/s/AKfycbya5eWKkDX7zQpSzFIG236Q4TOG_5CSAnXax2XnxJYGWDuwyd9PYvgpYI_61htglum0/exec";

function trackToSheets(sheetName, rowData) {
  if (!SHEETS_WEBHOOK_URL || SHEETS_WEBHOOK_URL.indexOf("YOUR_") === 0) return;
  rowData.url = window.location.href;
  var payload = JSON.stringify({ sheet: sheetName, row: rowData });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      SHEETS_WEBHOOK_URL,
      new Blob([payload], { type: "text/plain" }),
    );
  } else {
    fetch(SHEETS_WEBHOOK_URL, {
      method: "POST",
      mode: "no-cors",
      body: payload,
    });
  }
}

// --- Cart sync: orphaned upsell removal + popup sale state ---
function syncCart() {
  $.getJSON("/cart.js", function (cart) {
    // Remove orphaned upsells (LASTTIME items that exist without regular items)
    if (cart.items.length > 0) {
      var upsellItems = cart.items.filter(function (item) {
        return item.properties && item.properties.LASTTIME;
      });
      var regularItems = cart.items.filter(function (item) {
        return !item.properties || !item.properties.LASTTIME;
      });

      if (upsellItems.length > 0 && regularItems.length === 0) {
        var updates = {};
        upsellItems.forEach(function (item) {
          updates[item.key] = 0;
        });
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: JSON.stringify({ updates: updates }),
          contentType: "application/json",
          success: function () {
            if (window.refreshCartDrawer) {
              window.refreshCartDrawer(true, null);
            }
          },
        });
      }
    }

    // Sync pre-purchase popup sale state with current cart
    var isSale = cart.original_total_price >= 10000;
    $(".pu_outer").each(function () {
      applyPuSaleState($(this), isSale);
    });
  });
}

// --- Popup countdown timer ---
var _popupTimerInterval = null;

function startPopupTimer(puOuterEl) {
  if (_popupTimerInterval) {
    clearInterval(_popupTimerInterval);
    _popupTimerInterval = null;
  }

  var totalSeconds = 5 * 60;
  var $timer = $(puOuterEl).find(".pu_announcment-timer");

  function formatTime(s) {
    var m = Math.floor(s / 60);
    var sec = s % 60;
    return (m < 10 ? "0" : "") + m + ":" + (sec < 10 ? "0" : "") + sec;
  }

  $timer.text(formatTime(totalSeconds));

  _popupTimerInterval = setInterval(function () {
    totalSeconds -= 1;
    if (totalSeconds < 0) totalSeconds = 0;
    $timer.text(formatTime(totalSeconds));
    if (totalSeconds === 0) {
      clearInterval(_popupTimerInterval);
      _popupTimerInterval = null;
    }
  }, 1000);
}

function stopPopupTimer() {
  if (_popupTimerInterval) {
    clearInterval(_popupTimerInterval);
    _popupTimerInterval = null;
  }
}

function applyPuSaleState($popup, isSale) {
  var $annTop = $popup.find('.pu_announcment-top');

  if (isSale) {
    var saleTop = $annTop.data('top-sale');
    var saleMain = $annTop.data('main-sale');
    if (saleTop) {
      $annTop.find('h4').html(saleTop);
      $annTop.find('h3').html(saleMain || '');
    }
    $popup.find('.pu_price').each(function () {
      var salePrice = $(this).data('price-sale');
      if (salePrice) {
        $(this).find('.pu_price-curr').text(salePrice);
        $(this).find('.pu_price-badge').text('30% OFF TODAY');
      }
    });
    $popup.find('.pu_accept-btn').attr('data-discount', '30');
    $popup.find('.pu_announcment').addClass('pu_announcment--sale');
  } else {
    var origTop = $annTop.data('top');
    var origMain = $annTop.data('main');
    if (origTop) {
      $annTop.find('h4').html(origTop);
      $annTop.find('h3').html(origMain || '');
    }
    $popup.find('.pu_price').each(function () {
      var basePrice = $(this).data('price-base');
      var baseBadge = $(this).data('badge-base');
      if (basePrice) {
        $(this).find('.pu_price-curr').text(basePrice);
        $(this).find('.pu_price-badge').text(baseBadge || '');
      }
    });
    var $btn = $popup.find('.pu_accept-btn');
    $btn.attr('data-discount', $btn.data('discount-orig') || '');
    $popup.find('.pu_announcment').removeClass('pu_announcment--sale');
  }
}

$(document).ready(function () {
  // Run on page load in case cart already has orphaned upsells
  syncCart();

  // Hook into refreshCartDrawer so every cart update triggers the check
  setTimeout(function () {
    var _orig = window.refreshCartDrawer;
    if (_orig) {
      window.refreshCartDrawer = function () {
        var result = _orig.apply(this, arguments);
        setTimeout(syncCart, 600);
        return result;
      };
    }
  }, 0);

  // --- Shade selector (scoped to each popup) ---
  $(document).on("click", ".pu_outer .simple-product_shade", function () {
    var $shade = $(this);
    var $puOuter = $shade.closest(".pu_outer");
    var variantId = $shade.attr("data-id");
    var variantTitle = $shade.attr("data-title");

    $puOuter.find(".simple-product_shade").removeClass("active");
    $shade.addClass("active");

    $puOuter.find(".simple-product_shades_info__js").html(variantTitle);

    $puOuter.find(".pu_main-img-src").addClass("hided");
    $puOuter
      .find('.pu_main-img-src[data-id="' + variantId + '"]')
      .removeClass("hided");

    $puOuter.find(".pu_price").addClass("hided");
    $puOuter
      .find('.pu_price[data-id="' + variantId + '"]')
      .removeClass("hided");
  });

  // --- Checkout button intercept ---
  $(document).on("click", ".cd_checkoutbnt", function (e) {
    e.preventDefault();

    $.getJSON("/cart.js", function (cart) {
      var hasOffer = cart.items.some(function (item) {
        return item.properties && item.properties.LASTTIME;
      });

      if (hasOffer || cart.items.length === 0 || $(".pu_outer").length === 0 || isPuDismissed()) {
        trackToSheets("Popup_visibility_old", {
          event: "Popup_no",
          timestamp: new Date().toISOString(),
        });
        if (window.sendTrackingEvent) sendTrackingEvent("theme_caught_click");
        if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
        window.location.href = "/checkout";
        return;
      }

      var firstProductId = String(cart.items[0].product_id);
      var $matchingPopup = $(
        '.pu_outer[data-product-id="' + firstProductId + '"]:not([data-fallback="true"])',
      );

      var $fallbackPopup = $(".pu_outer[data-fallback='true']");
      var $popupToShow = $matchingPopup.length ? $matchingPopup : $fallbackPopup;

      if ($popupToShow.length) {
        applyPuSaleState($popupToShow, cart.original_total_price >= 10000);
        $popupToShow.css("display", "flex");
        $("body").css("overflow", "hidden");
        requestAnimationFrame(function () {
          $popupToShow.addClass("is-open");
          trackToSheets("Popup_visibility_old", {
            event: "Popup_show",
            product_id: firstProductId,
            timestamp: new Date().toISOString(),
          });
          if (window.sendTrackingEvent) sendTrackingEvent("theme_caught_click");
        });
      } else {
        trackToSheets("Popup_visibility_old", {
          event: "Popup_no",
          timestamp: new Date().toISOString(),
        });
        if (window.sendTrackingEvent) sendTrackingEvent("theme_caught_click");
        if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
        window.location.href = "/checkout";
      }
    });
  });

  // --- Decline: close popup and go to checkout ---

  $(document).on("click", ".pu_inner-close", function () {
    var $puOuter = $(this).closest(".pu_outer");
    var productId = $puOuter.attr("data-product-id");
    trackToSheets("Popups_acceptance_old", {
      event: "Upsell_declined",
      product_id: productId,
      timestamp: new Date().toISOString(),
    });
    setPuDismissedCookie();
    $puOuter.removeClass("is-open");
    $("body").css("overflow", "");
    setTimeout(function () {
      $puOuter.css("display", "none");
      if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
      window.location.href = "/checkout";
    }, 300);
  });

  $(document).on("click", ".pu_decline-btn", function () {
    var $puOuter = $(this).closest(".pu_outer");
    var productId = $puOuter.attr("data-product-id");
    trackToSheets("Popups_acceptance_old", {
      event: "Upsell_declined",
      product_id: productId,
      timestamp: new Date().toISOString(),
    });
    setPuDismissedCookie();
    $puOuter.removeClass("is-open");
    $("body").css("overflow", "");
    setTimeout(function () {
      $puOuter.css("display", "none");
      if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
      window.location.href = "/checkout";
    }, 300);
  });

  // --- Accept: add upsell with OFFER: 35% property, then checkout ---
  $(document).on("click", ".pu_accept-btn", function () {
    $(this).addClass("loading");
    var $puOuter = $(this).closest(".pu_outer");
    var discountNeeded = $(this).attr("data-discount");
    var productId = $puOuter.attr("data-product-id");
    var acceptClickedAt = Date.now();
    var variantId = $puOuter
      .find(".simple-product_shade.active")
      .attr("data-id");

    if (!variantId) {
      variantId = $puOuter.find(".pu_main-img-src").first().attr("data-id");
    }

    if (!variantId) return;

    trackToSheets("Popups_acceptance_old", {
      event: "Upsell_accepted",
      product_id: productId,
      variant_id: variantId,
      timestamp: new Date().toISOString(),
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1,
        properties: {
          OFFER: "" + discountNeeded + "%",
          LASTTIME: "OFFER",
        },
      }),
      contentType: "application/json",
      success: function () {
        var duration_ms = Date.now() - acceptClickedAt;
        trackToSheets("Popup_timing_old", {
          product_id: productId,
          variant_id: variantId,
          duration_ms: duration_ms,
          timestamp: new Date().toISOString(),
        });
        if (window.sendTrackingEvent) sendTrackingEvent("going_to_checkout");
        window.location.href = "/checkout";
        $(".pu_accept-btn").removeClass("loading");
        $(".pu_outer").removeClass("is-open");
        $("body").css("overflow", "");
      },
      error: function () {
        $(".pu_accept-btn").removeClass("loading").addClass("error");
        $(".pu_outer").removeClass("is-open");
        $("body").css("overflow", "");
      },
    });
  });

  // --- MutationObserver: start/stop timer whenever is-open is toggled on any .pu_outer ---
  document.querySelectorAll(".pu_outer").forEach(function (el) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var hadIsOpen = mutation.oldValue
          ? mutation.oldValue.split(" ").indexOf("is-open") !== -1
          : false;
        var hasIsOpen = el.classList.contains("is-open");
        if (hasIsOpen && !hadIsOpen) {
          startPopupTimer(el);
        } else if (!hasIsOpen && hadIsOpen) {
          stopPopupTimer();
        }
      });
    }).observe(el, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });
  });
});
